module.exports = __webpack_public_path__ + "img/smartphone.f8d2ffb4.svg";